<template>
  <ValidationObserver
    ref="goalItemObserver"
    v-slot="{ errors }">
    <SectionBox
      v-show="canEdit || hasName || hasScore"
      class="action-goal-item">
      <fieldset :disabled="disabled">
        <InputContainer
          v-show="canShowActionGoalName"
          class="mb-2">
          <template #prepend>
            <div class="d-flex align-items-center">
              <ChangedBox
                class="mr-2"
                :active="hasNameChanged" />
              <img
                src="@/assets/images/icon_flag.svg"
                class="flag-icon mr-2"
                style="width:20px;height:20px;">
            </div>
          </template>
          <BaseTextareaWithProvider
            v-if="canEditActionGoalName"
            field-class="pl-8 font-weight-bold fs-m"
            :value="_value.name"
            name="行動目標名"
            placeholder="行動目標を入力してください"
            empty-str-to-null
            :response-errors="responseErrors"
            :rows="1"
            :max-rows="3"
            vid="name"
            autocomplete="off"
            @input="onInputName" />
          <DisplayFormField
            v-else
            class="pl-8"
            bold>
            {{ _value.name }}
          </DisplayFormField>
        </InputContainer>
        <BaseSliderWithErrorMessage
          v-show="canShowActionGoalScore"
          v-model="_value.score"
          :disabled="disabled || !hasName"
          min="0"
          max="5"
          :response-errors="responseErrors"
          error-text-color="danger"
          error-text-bold
          vid="score" />
      </fieldset>
    </SectionBox>
  </ValidationObserver>
</template>

<script>
import BaseSliderWithErrorMessage from '@/components/parts/BaseSliderWithErrorMessage.vue'
import BaseTextareaWithProvider from '@/components/parts/BaseTextareaWithProvider.vue'
import SectionBox from '@/components/parts/SectionBox.vue'
import ChangedBox from '@/components/parts/ChangedBox.vue'
import InputContainer from '@/components/parts/InputContainer.vue'
import DisplayFormField from '@/components/view/mandala_evaluation/DisplayFormField.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'MandalaEvaluationFormActionGoalItem',
  components: {
    BaseTextareaWithProvider,
    BaseSliderWithErrorMessage,
    SectionBox,
    ChangedBox,
    InputContainer,
    DisplayFormField
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    selectedMandalaGoalTemplate: {
      type: Object,
      required: true
    },
    lastMonthActionGoal: {
      type: Object,
      default: null
    },
    responseErrors: {
      type: Object,
      default: () => {}
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    hasEntryName: {
      type: Boolean,
      required: true
    },
    isMine: {
      type: Boolean,
      default: false
    },
    templateActionGoal: {
      type: Object,
      default: null
    },
  },
  computed: {
    ...mapGetters('auth', ['isManager']),
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    hasNameChanged() {
      if (!this.lastMonthActionGoal) {
        return false
      }
  
      // 改行文字を正規化して比較（textareaのvalueと同じ形式に）
      const normalizeNewlines = (str) => {
        if (!str) return ''
        // \r\n と \r を \n に統一（textareaのvalueと同じ形式）
        return str.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
      }
  
      const lastMonthName = normalizeNewlines(this.lastMonthActionGoal.name)
      const currentName = normalizeNewlines(this._value.name)
  
      return lastMonthName !== currentName
    },
    hasName() {
      return !!this._value.name
    },
    hasScore() {
      return this._value.score != null
    },
    disabled() {
      return !this.canEdit || !this.hasEntryName
    },
    isLockActionGoalScores() {
      return this.selectedMandalaGoalTemplate.isLockActionGoalScores
    },
    canShowActionGoalName() {
      return this.isMine || this.isManager || !this.selectedMandalaGoalTemplate.isLockActionGoalNames
    },
    canShowActionGoalScore() {
      return this.isMine || this.isManager || !this.selectedMandalaGoalTemplate.isLockActionGoalScores
    },
    hasTemplateActionGoalName() {
      if (!this.templateActionGoal) {
        return false
      }
      return !['', null].includes(this.templateActionGoal.name)
    },
    canEditActionGoalName() {
      return this.canEdit && !this.hasTemplateActionGoalName
    }
  },
  watch: {
    // 編集しようとした際にテンプレート側に項目名が設定されていたらその項目名で上書きする
    canEdit: {
      immediate: true,
      handler(val) {
        if (val && this.hasTemplateActionGoalName) {
          this._value.name = this.templateActionGoal.name
        }
      }
    }
  },
  methods: {
    onInputName(newName) {
      if (!newName) {
        this._value.score = null
      }
      this._value.name = newName
    }
  }
}
</script>

<style lang="scss" scoped>
.action-goal-item {
}
</style>